export enum StorageKey {
    TokenExpiration = 'TokenExpiration',
    ApiError = 'ApiError',
    BackendFailure = 'BackendFailure',
    Authenticated = 'Authenticated',
    SearchParams = 'SearchParams',
    BlackThemeEnabled = 'BlackThemeEnabled',
}

export interface StorageReader {
    read: (key: StorageKey) => any
}

export interface StorageWriter {
    write: (key: StorageKey, value: any) => any
    remove: (key: StorageKey) => any
}

const inMemoryStore: Record<string, string> = {}

export const memoryStorage: Storage = {
    getItem: (key) => inMemoryStore[key] ?? null,
    setItem: (key, value) => { inMemoryStore[key] = value },
    removeItem: (key) => { delete inMemoryStore[key] },
    clear: () => { Object.keys(inMemoryStore).forEach(k => delete inMemoryStore[k]) },
    key: (index) => Object.keys(inMemoryStore)[index] ?? null,
    get length() { return Object.keys(inMemoryStore).length }
}

export function storageReaderFactory(prefix: string, storage: Storage = localStorage): StorageReader {
    return {
        read: (key: StorageKey) => {
            const value = storage.getItem(prefix + key)
            return value ? JSON.parse(value) : {}
        }
    }
}

export function storageWriterFactory(prefix: string, storage: Storage = localStorage): StorageWriter {
    return {
        write: (key: StorageKey, value: any) => {
            let res
            if (value) {
                const old = storage.getItem(prefix + key)
                if (old) {
                    const oldVal = JSON.parse(old)
                    if (typeof oldVal === 'object') {
                        res = {...oldVal, ...value}
                        storage.setItem(prefix + key, JSON.stringify(res))
                    } else {
                        res = oldVal + value
                        storage.setItem(prefix + key, JSON.stringify(res))
                    }
                } else {
                    res = value
                    storage.setItem(prefix + key, JSON.stringify(res))
                }
            }
            return res
        },
        remove: (key: StorageKey) => {
            storage.removeItem(prefix + key)
        }
    }
}


// WEBPACK FOOTER //
// ./src/util/Storage.tsx